export const REPORT_TYPE_MAP = {
  Wafeq_vertical_balance_sheet_analysis: "verticalBalance",
  Wafeq_horizontal_balance_sheet_analysis: "horizontalBalance",
  Wafeq_vertical_income_statement_common_size_pl: "verticalIncome",
  Wafeq_cash_flow_analysis: "cashFlow",
  Wafeq_trend_analysis: "trend",
  Wafeq_working_capital_analysis: "workingCapital",
  Wafeq_profitability_ratios: "profitability",
  Wafeq_liquidity_ratios: "liquidity",
  Wafeq_leverage_ratios: "solvency",
  Wafeq_activity_ratios: "activity",
  Wafeq_operating_efficiency_analysis: "efficiency",
  Wafeq_detailed_expense_analysis: "expense",
  Wafeq_advanced_profitability_analysis: "advancedProfitability",
  Wafeq_advanced_cost_analysis: "costAnalysis",
  Wafeq_break_even_analysis: "breakEven",
  Wafeq_financial_forecasting_analysis: "forecasting",
  Wafeq_account_movement_analysis: "accountMovement",
  Wafeq_accounts_receivable_ageing_analysis: "receivables",
  Wafeq_accounts_payable_payment_analysis: "payables",
  Wafeq_cash_conversion_cycle: "ccc",
  Wafeq_sensitivity_analysis: "sensitivity",
  Wafeq_dupont_analysis: "dupont",
  Wafeq_financial_volatility_analysis: "volatility",
  Wafeq_predictive_risk_model: "riskModel",
  Wafeq_earnings_quality_index: "earningsQuality",
  Wafeq_financial_sustainability_index: "sustainability",
  Wafeq_financial_stability_index: "financialStability",
  Wafeq_earnings_stability_index: "earningsStability",
  Wafeq_cash_sufficiency_ratio: "liquidity",
  Wafeq_financial_forecasting_model: "forecasting",
  Wafeq_scenario_analysis: "scenario",
  Wafeq_variance_analysis: "variance",
  Wafeq_correlation_analysis: "correlation",
  Wafeq_regression_trend_analysis: "trend",
  Wafeq_benchmarking_analysis: "benchmarking",
  Wafeq_customizable_report_placeholder: "general",
};

export const mapApiReportKeyToType = (reportKey) =>
  REPORT_TYPE_MAP[reportKey] || "general";
